import React  from 'react';
import { observer, inject } from 'mobx-react';
import styled, { css } from 'styled-components';

const YInput =  inject('stepStore')(observer(({label, name, require, stepStore}:{
  label:string,
  name: string,
  require?:boolean,
  stepStore?: any
}) => {
  const change = (e:any,name:string) => {
    stepStore.updateForm(name, e.target.value);
  }

  return (
    <Container
      hasValue={stepStore.form[name]}
      require={!!require}
      error={stepStore.valid[name] && !stepStore.valid[name].valid}
    >
      <input type='text' value={stepStore.form[name]} id={name} autoComplete='off' onChange={(e)=>change(e,name)}/>
      <label htmlFor={name}>
        {label}
        {
          stepStore.valid[name] && !stepStore.valid[name].valid && <Error>{stepStore.valid[name].msg}</Error>
        }
      </label>
    </Container>
  )
}))

export default YInput;

interface IContainer {
  hasValue: boolean
  require: boolean
  error: boolean
}
const hasValueLabel=css`
  transition: top 0.2s ease;
  top: -18px;
  font-size:14px;
  color: #3E3F3F;
  line-height:18px;
`

const normalLabel = css`
  font-size:16px;
  font-weight:400;
  color: #3E3F3F;
  line-height:22px;
  top: 6px;
  left: 0;
`
const require = css`
  content: '*';
  color: #E07C7C;
  margin-left: 3px;
`
const Error = styled.span`
  position: absolute;
  content: ' ';
  left: 80px;
  top: 0;
  color: #E07C7C;
`
const Container = styled.div`
  position: relative;
  width: 415px;
  display: inline-block;
  margin-top: 36px;
  label{
    position: absolute;
    width: 100%;
    left: 0;
    ${(props: IContainer) => (
      props.hasValue ? hasValueLabel: normalLabel
    )}
    &::after{
      ${(props: IContainer) => (
        props.require ? require: ''
      )}
    }
  }
  
  input{
    width: 100%;
    height: 39px;
    border: none;
    border-bottom: 1px solid ${(props: IContainer) => props.error ? '#E07C7C' : (props.hasValue ? '#1967FA' : '#D0D6E6')};
    outline: none;
    font-size:15px;
    color:rgba(25,103,250,1);
    &:focus{
      transition: border-bottom-color 0.2s ease;
      border-bottom: 1px solid #1967FA;
    }
    &:focus ~label{
      ${() => hasValueLabel}
    }
  }
  &:nth-child(2n-1){
    margin-right: 38px;
  }
`